import Address from "@mapmycustomers/shared/types/Address";
import { isEmptyString } from "@mapmycustomers/shared/util/stringUtils";

import { not } from "@app/util/logic";

const getAddressForStateAndCountry = (address: Address) => {
  address.address = [address.region, address.country].filter(not(isEmptyString)).join(", ");
  return address;
};

export default getAddressForStateAndCountry;
